module.exports = __webpack_public_path__ + "img/IMG_9786_L_Foamcore.dda93c9d.jpg";